import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import News from './views/News.vue'
import NewsContent from './views/NewsContent.vue'
import NewsCompany from './views/NewsCompany.vue'
import Party from './views/Party.vue'
import Career from './views/career'
import CareerNews from './views/career/CareerNews.vue'
import Job from './views/career/Job.vue'
import Relationship from './views/relation/Relationship.vue'
import Responsibility from './views/relation/Responsibility.vue'
import Law from './views/Law.vue'
import Cooperation from './views/Cooperation.vue'
import Product from './views/product'
import qualityAssunce from './views/product/qualityAssunce'
import productAssunce from './views/product/productAssunce'
import ProductIntroduce from './views/product/ProductIntroduce'
import Use from './views/product/Use'
import Service from './views/product/Service'
import Culture from './views/about/Culture.vue'
import Leaders from './views/about/Leaders.vue'
import Manager from './views/about/manager.vue'
import Honor from './views/about/Honor.vue'
import Contact from './views/about/Contact.vue'
import Search from './views/Search.vue'
import Development from './views/about/Development.vue'
import DevelopmentPlay from './views/about/DevelopmentPlan.vue'
import humanNews from './views/career/humanNews.vue'
import talentNews from './views/career/talentNews.vue'
import api from './request/api'

const {
  openaApi
} = api
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routerV = new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about/:type',
      name: 'about',
      component: About
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/news/:type',
      component: News,
    },
    {
      path: '/newsCompany',
      name: 'newsCompany',
      enName: 'test',
      component: NewsCompany
    },
    {
      path: '/party/:type',
      name: 'party',
      component: Party
    },
    {
      path: '/newsContent',
      name: 'newsContent',
      component: NewsContent,
    },
    {
      path: '/career',
      name: 'career',
      component: Career
    },
    {
      path: '/careerNews/:type',
      name: 'careerNews',
      component: CareerNews
    },
    
    {
      path: '/job',
      name: 'Job',
      component: Job
    },
    {
      path: '/relationship/:type',
      name: 'relationship',
      component: Relationship
    },
    /*     {
          path: '/stock',
          name: 'stock',
          component: Relationship
        }, */
    {
      path: '/responsibility',
      name: 'responsibility',
      component: Responsibility
    },
    {
      path: '/law',
      name: 'law',
      component: Law
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: Cooperation
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/productIntroduce/:type',
      name: 'productIntroduce',
      component: ProductIntroduce
    },
    {
      path: '/quality',
      name: 'qualityAssunce',
      component: qualityAssunce
    },
    {
      path: '/assunce',
      name: 'productAssunce',
      component: productAssunce
    },
    {
      path: '/use/:type',
      name: 'use',
      component: Use
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/leaders',
      name: 'leaders',
      component: Leaders
    },
    {
      path: '/manager',
      name: 'manager',
      component: Manager
    },
    {
      path: '/honor',
      name: 'honor',
      component: Honor
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/development',
      name: 'development',
      component: Development
    },
    {
      path: '/developmentplan',
      name: 'developmentplan',
      component: DevelopmentPlay
    },
    {
      path: '/human',
      name: 'humanNews',
      component: humanNews
    },
    {
      path: '/talent',
      name: 'talentNews',
      component: talentNews
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    const {
      type
    } = to.params
    let noNeed = "culture,contact,two,three,note"
    let intener = noNeed.indexOf(type)
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 500)
      })
    } else {
      if (!type || intener == -1) {
        return {
          x: 0,
          y: 0
        }
      }
    }

  },
})

function checkAuditTime(beginTime, endTime) {
  var nowDate = new Date();
  var beginDate = new Date(nowDate);
  var endDate = new Date(nowDate);

  var beginIndex = beginTime.lastIndexOf("\:");
  var beginHour = beginTime.substring(0, beginIndex);
  var beginMinue = beginTime.substring(beginIndex + 1, beginTime.length);
  beginDate.setHours(beginHour, beginMinue, 0, 0);

  var endIndex = endTime.lastIndexOf("\:");
  var endHour = endTime.substring(0, endIndex);
  var endMinue = endTime.substring(endIndex + 1, endTime.length);
  endDate.setHours(endHour, endMinue, 0, 0);
  return nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime();
}


routerV.beforeEach((to, from, next) => {
  openaApi().then((res) => {
    const {
      Value
    } = res
    // const Value = true
    sessionStorage.setItem('openState',Value)
    // if (checkAuditTime("22:00", "24:00") || checkAuditTime("0:00", "8:00")) {
    if (Value) {
      if (to.path === '/') {
        next()
      } else {
        next({
          path: '/'
        })
      }
    } else {
      next()
    }
  });

})

export default routerV